import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/core/auth.service';
import { ErrorService } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { UtilsService } from 'src/app/core/utils.service';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { ERROR_PASSWORD_MISMATCH_CODE, LOCAL_USERNAME_KEY } from 'src/app/shared/constants/operationals';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-auth-new-password-form',
  templateUrl: './auth-new-password-form.component.html',
  styleUrls: ['./auth-new-password-form.component.scss'],
})
export class AuthNewPasswordFormComponent {
  new_password_form_group: FormGroup = this.form_service.auth_new_password_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_password_visible: boolean = false;
  is_complete_pss_running: boolean = false;
  cognito_user?: CognitoUser;

  constructor(
    private form_service: FormService,
    private utils_service: UtilsService,
    private auth_service: AuthService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {
    this.cognito_user = this.auth_service.pending_cognito_user;
  }

  onCompleteClick(): void {
    if (this.isFormValid() && this.cognito_user) {
      const password: string = this.new_password_form_group.get(this.form_service.password_label)?.value;
      const password_confirm: string = this.new_password_form_group.get(
        this.form_service.password_confirm_label,
      )?.value;

      if (password == password_confirm) {
        this.completeNewPassword(password, this.cognito_user);
      } else {
        this.error_service.processApiError(ERROR_PASSWORD_MISMATCH_CODE);
      }
    }
  }

  completeNewPassword(new_password: string, cognito_user: CognitoUser): void {
    this.is_complete_pss_running = true;
    this.auth_service.completeNewPassword(cognito_user, new_password).subscribe({
      next: () => {
        this.navigation_service.toAuthSignin();
        this.is_complete_pss_running = false;
      },
      error: error => {
        this.error_service.processApiError(error.code, error.message);
        this.is_complete_pss_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.new_password_form_group);
  }

  hasPssLengthError(confirm: boolean): boolean | undefined {
    return this.utils_service.hasPssLengthError(
      this.new_password_form_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }

  hasPssPatternError(confirm: boolean): boolean | undefined {
    return this.utils_service.hasPssPatternError(
      this.new_password_form_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }

  getPssFormFieldErrorClass(confirm: boolean): {
    [key: string]: boolean | undefined;
  } {
    return this.utils_service.getPssFormFieldErrorClass(
      this.new_password_form_group,
      confirm ? this.form_service.password_confirm_label : this.form_service.password_label,
    );
  }
}
